// website crawling is consolidated inside repo creation
// Comparision qna, selection mode and cleassify query are already consolidated in qna
export const OPERATION_LABELS = Object.freeze({
    REPO_CREATION: 'Repo creation',
    FILE_UPLOAD: 'File upload',
    RECRAWL: 'Recrawl',
    QNA: 'Q&A',
    KG_CREATION: 'Knowledge graph creation',
    AGENT_CREATION: 'Agent creation',
    EXTRACTION: 'Extraction',
    AUTO_EXTRACTION: 'Auto extraction',
    'DATABASE QUERY': 'Database query', // legacy rows only; new dashboard queries use DASHBOARD
    DASHBOARD: 'Dashboard',
});
